import { render, staticRenderFns } from "./StudentAvatar.vue?vue&type=template&id=ea2b4bf6&scoped=true"
import script from "./StudentAvatar.vue?vue&type=script&lang=js"
export * from "./StudentAvatar.vue?vue&type=script&lang=js"
import style0 from "./StudentAvatar.vue?vue&type=style&index=0&id=ea2b4bf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2b4bf6",
  null
  
)

export default component.exports